import React, { useEffect, useState } from 'react'
import { useParams, Link as RouterLink } from 'react-router-dom'
import { useCourse } from '../../course/hooks';
import Loader from '../../../components/Loader';
import { Link, Box, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateIcon from '@mui/icons-material/Create';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { MarkupEditor, parseContentToParagraph } from '../../../components/markupEditor';


export const DiagnosticAssessment = () => {

    const { id } = useParams();
    const { loadLessonPlan, lessonPlan, loading, loadCurrent, current } = useCourse();
    const [sectionData, setSectionData] = useState({});
    const [chapterData, setChapterData] = useState({});
    const [assessments, setAssessments] = useState();
    const [openModal, setOpenModal] = React.useState(false);


    useEffect(() => {
        if (id) {
            loadCurrent({ id })
            loadLessonPlan({ id })
        }
    }, [id])

    useEffect(() => {
        if (lessonPlan) {
            const section = lessonPlan?.sections?.[0];
            const chapter = section?.chapters?.[0];
            const assessment = chapter?.assessments;
            setSectionData(section);
            setChapterData(chapter);
            setAssessments(assessment);
        }
    }, [lessonPlan])


    return (
        <>{loading ? <Loader /> :
            <Box
                sx={{
                    padding: '0px',
                    maxWidth: '100%',
                }}>
                <div className='course'>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Typography
                            align="left"
                            variant="h1"
                            color="primary.blue"
                            sx={{
                                margin: '0',
                                fontWeight: '700',
                                lineHeight: '1.5',
                                fontSize: '1.8rem',
                            }}>Diagnostic Assessment - ({current?.courseName})</Typography>

                    </Box>
                    <Grid style={styles.gridContainer} spacing={2} alignItems="center">
                        <Grid m={1} item xs={12}>
                            <MarkupEditor
                                content={chapterData?.content}
                                keyWords={chapterData?.keyWords}
                                irLevels={Array.from(new Array(9)).map((e, i) => `L${i}`)}
                                disabled={true}
                            />
                        </Grid>
                        <Grid m={1} item xs={12}>
                            <Box sx={{ color: 'var(--mui-palette-primary-blue)', width: '80%', fontWeight: 'bold' }}> Assessments</Box>
                            {assessments && assessments?.map((assessment, i) => {
                                return (
                                    <Box key={assessment?.id} sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        background: '#B2B0FF',
                                        alignItems: 'center',
                                        p: 1,
                                        mt: 2,
                                        borderRadius: '5px',
                                    }}>{assessment?.name}

                                        <div style={styles.actionBtn} >
                                           <Link style={styles.assessmentsLink} component={RouterLink} to={`assessment/${lessonPlan?.id}/section/${sectionData.sectionId}/chapter/${chapterData.chapterId}/edit/${assessment?.id}`} title="Edit Assessment"> <CreateIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} /></Link>
                                            {/* <Button sx={{ color: 'var(--mui-palette-primary-blue)', p: 0 }} variant='text' onClick={() => removeAssessment(assessment)} placeholder={<DeleteIcon />} /> */}
                                        </div>
                                    </Box>
                                )
                            })}
                            {!assessments?.length > 0 &&
                                   <Link style={styles.assessmentsLink} component={RouterLink} to={`assessment/${lessonPlan?.id}/section/${sectionData?.sectionId}/chapter/${chapterData?.chapterId}/create`}>Create Assessment <ArrowForwardIcon sx={{ ml: 1 }} /></Link>}
                        </Grid>
                    </Grid>
                </div>
            </Box>
        }</>
    )
}

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    gridContainer: {
        mt: 2,
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    assessmentsLink: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center'
    },
}
